import { Breadcrumb, Button, Icon, Modal, Search, TextArea } from "pepsico-ds";
import { useTranslation } from "react-i18next";
import { toast, ToastContainer } from 'react-toastify';
import "./pam_safe_create_update.css";
import { useEffect, useState, useRef, useCallback } from "react";
import { useLoading } from "../../loader";
import axios from "axios";
import { useNavigate } from "react-router-dom";

const PamSafeAccessRequest = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { REACT_APP_API_ENDPOINT } = process.env;
  const { showLoader, hideLoader } = useLoading();
  const [description, setDescription] = useState("");
  const [isMobile, setIsMobile] = useState(false);
  const [loader, setLoader] = useState(false);
  const [disableGpidSearch, setDisableGpidSearch] = useState(false);
  const [disableSafe, setDisableSafe] = useState(false);
  const [querySafe, setQuerySafe] = useState('');
  const [safes, setSafes] = useState([]);
  const [selectedSafes, setSelectedSafes] = useState([]);
  const [existingSafeMembers, setExistingSafeMembers] = useState([]);
  const [userSvcData, setUserSvcData] = useState('');
  const [showModal, setShowModal] = useState(false);
  const [copyButtonText, setCopyButtonText] = useState(t('nonArExtension.copy'));
  const [requestData, setRequestData] = useState(null);
  function useDebouncedCallback(callback, delay = 1000) {
    const timerRef = useRef();

    const debounced = useCallback((...args) => {
      if (timerRef.current) {
        clearTimeout(timerRef.current);
      }
      timerRef.current = setTimeout(() => {
        callback(...args);
      }, delay);
    }, [callback, delay]);
    useEffect(() => {
      return () => {
        if (timerRef.current) {
          clearTimeout(timerRef.current);
        }
      };
    }, []);

    return debounced;
  }

  const debouncedSearchSafe = useDebouncedCallback((q, isMember = false) => {
    if (q?.trim().length >= 3) {
      safeSerach(q, isMember);
    } else {
      setSafes([]);
    }
  }, 2000);

  const safeSerach = async(val) => {
    if (!val || val?.length < 3) {
      return
    }
    showLoader();
    setDisableSafe(true);
    setLoader(true);
    try{
      const response = await axios.get(REACT_APP_API_ENDPOINT + `pam/safeManagement/safes?search=${val}`);
      hideLoader();
      setDisableSafe(false);
      setLoader(false);

      if (response?.data?.status === "Failed") {
        toast.error(response?.data?.errorMessage || t("mypam.an_error_occurred"));
        setSafes([]);
        return;
      }

      if (!response?.data?.safes) {
        toast.error(t("mypam.an_error_occurred"))
        return;
      }
      const mapped = Object.values(response?.data?.safes).map(item => ({
        id: item,
        label: item
      }));

      setSafes(mapped)
    }catch(error){
      hideLoader();
      setDisableSafe(false);
      setLoader(false);
      setSafes([]);
      toast.error(error?.response?.data?.errorMessage || error?.message || t("mypam.an_error_occurred"));
      console.log('error', error);
    }
  }

  const addToSafe = (val) => {
    if (!val?.id) return;

    const parts = String(val.id).split('-');
    const selectedSafe = parts[parts.length - 1];

    if (!selectedSafe) return;

    const safeToAdd = { ...val, id: selectedSafe };
      setSelectedSafes((prev) =>
        prev.some((item) => item.id === selectedSafe)
          ? prev
          : [...prev, safeToAdd]
      );
  };

  const clearSate = () => {
    setQuerySafe('')
  }

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    checkMobile();
    window.addEventListener('resize', checkMobile);

    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  const resetFields = () => {
    setSelectedSafes([]);
    setDescription("");
  }

  const handleAccessRequest = () => {
    showLoader();
    setLoader(true);
    const payload = {
      safeNames: selectedSafes?.map?.((rec) => rec?.id),
      businessJustification: description
    };
    axios.post(REACT_APP_API_ENDPOINT + "pam/safeManagement/accessRequest", payload)
      .then((response) => {
        if (!response?.data?.success) {
          toast.error(response?.data?.errorMessage || response?.data?.message, "error");
          hideLoader();
          setLoader(false);
        }
        else {
          setShowModal(true);
          setRequestData(response?.data);
          toast.success(response?.data?.message, "success");
          hideLoader();
          setLoader(false);
          resetFields();
        }
      })
      .catch((error) => {
        hideLoader();
        setLoader(false);
        console.error("Error fetching data:", error);
      });
  }

  const closeModal = () => {
      setShowModal(false);
  }

  const onClickCopynumber = () => {
      if (requestData?.requestNumber) {
          navigator.clipboard.writeText(requestData?.requestNumber?.toString?.()).then(() => {
              setCopyButtonText(t('nonArExtension.copied'));
          }).catch(err => {
              console.error("Failed to copy text: ", err);
          });
      }
  };

  const onViewRequest = () => {
      const statePayload = { type: "requestNumber", value: requestData?.requestNumber};
      navigate("/audit-requests", { state: statePayload });
  }

  const renderConfirmModal = () => {
      return (
          <div className="confirm-modal">
              <Modal
                  showModal={showModal}
                  className="entra-request-success-modal"
                  onCloseModal={closeModal}
                  closeOnOutsideClick = {false}
                  notificationsProps={{
                      secondaryActionLabel: (
                          <>
                              <Icon
                                  alt="alt value"
                                  icon={copyButtonText == t('nonArExtension.copied') ? "check" : "content_copy"}
                                  size="medium"
                                  style={{ marginRight: '6px', display: 'unset' }}
                              />

                              {copyButtonText}
                          </>
                      ),
                      secondaryActionOnClick: onClickCopynumber,
                      text: `${requestData?.requestNumber}`,
                      title: t('nonArExtension.request_number_title'),
                      type: 'info'
                  }}
                  showAuxiliaryButton={false}
                  showLink={false}
                  showPrimaryButton={true}
                  primaryButtonProps={{
                      onClick: onViewRequest,
                      size: 'medium',
                      text: t('homePage.view_request'),
                      variant: 'primary'
                  }}
                  showSecondaryButton={false}
                  showSlot
                  showTertiaryButton={true}
                  tertiaryButtonProps={{
                      onClick: closeModal,
                      size: 'medium',
                      text: t('nonArExtension.back'),
                      variant: 'tertiary'
                  }}
                  showCloseButton={true}
                  style={{}}
                  text={<>
                      <div style={{ marginTop: '10px'}}>
                      <p  className="modal-para-text">{t('entraGuest.entra_request_confirmation_text')} 
                      </p>
                      </div>
                  </>}
                  title={t('entraGuest.entra_request_confirmation_title')}
                  type="fluid"
                  viewPort={`${isMobile ? "mobile" : "desktop"}`}
              >
                  <p style={{fontSize:'16px'}} className="modal-para-text">{`${t('entraGuest.see_all_your_requests_in_the')} `} <span className="view-request-txt">{`${t('entraGuest.view_request')} `}</span> {t('entraGuest.section_below')} 
                  </p>
              </Modal>
          </div>
      )
  }

  return <div className="create-update-safe-container h-100">
    <div className="create-update-safe-main-container ml-3">
      <Breadcrumb
        homeIcon={{
          icon: "home",
          onClick:()=>{
            navigate("/home")
          }
        }}
        breadcrumbs={[
          {
            label: t("menu.home"),
          },
          {
              label: <div onClick={()=>{
                navigate("/pam-safe-create-update")
              }}>{t("mypam.myPAM_safe_access_request")}</div>
          },
        ]}
        className=""
        onClick={function Xs() { }}
        useAnchor
        style={{ marginBottom: "1rem !important", width: "96%" }}
      />
      <div className="header_ar-title pb-0">
        <h1>{t("mypam.safe_access_request")}</h1>
      </div>
      <div className="udate-safe-container">
        <div className="row mx-0">
          <div class="accordion-item-container">
            <span class="icon $color-icon large material-icons-outlined $color-icon-default" role="img" aria-label="verified_user" style={{ fontSize: "24px" }}>
              inventory
            </span>
            <div class="accordion-item-label-container">
              <div class="content-group-title">
                <span class="title $font-body-medium">
                  {t("homePage.request_access")}
                </span>
              </div>
            </div>
          </div>
        </div>
        <div className={isMobile ? "form-field w-100" : "form-field w-50 mx-auto"} >
          <div className="mb-2" style={{ display: 'flex', justifyContent: "space-between" }}>
            <label className="safe-name" style={{ display: "flex", alignItems: "center" }}>
              {t("mypam.safe")}
            </label>
            <label className="required-text $font-xsmall-regular" style={{ color: "var(--color-text-secondary)" }}>*Required</label>
          </div>
          <Search
            isAutoComplete
            isClearable={querySafe?.length > 0}
            onClear={() => { clearSate(); setQuerySafe(""); }}
            maxLength={30}
            value={querySafe}
            isDisabled={disableSafe}
            onSelectOption={(val) => {
              addToSafe(val);
              setQuerySafe("");
              setSafes([]);
            }}
            onSearch={(event) => safeSerach(event)}
            onUpdate={(text) => {
              setQuerySafe(text);
              debouncedSearchSafe(text, true);
            }}
            placeholderText={t("mypam.search_by_minimum_4_character")}
            size="medium"
            style={{}}
            autoComplete="off"
            suggestions={safes}
            delay={0}
            limitSuggestions={safes.length}
          />
          {selectedSafes.length > 0 && <div className="mb-1">
            <label className="safe-name">{t("mypam.selected_safes")}</label>
            <div className="accountsAlign">
              {selectedSafes?.map((acc, index) => (
                <span key={acc?.id} className="endPointInfo mr-1">{acc?.id}{" "}
                  <Icon
                    alt="alt value"
                    className="icon $color-icon small material-icons-outlined ml-1"
                    icon="close"
                    size="small"
                    onClick={() => setSelectedSafes(selectedSafes.filter((rec) => acc?.id !== rec.id))}
                    style={{ color: 'white', cursor: "pointer" }}
                  />
                  {" "}</span>
              ))}
            </div>
          </div>
          }
        </div>
        <div className={isMobile ? "form-field w-100 business-justification" : "form-field w-50 mx-auto business-justification"} >
          <TextArea
            title={t("mypam.business_justification")}
            label={t("mypam.business_justification")}
            placeholder={t("mypam.provide_a_reason_for_requesting_access")}
            rows={4}
            style={{ width: "100%" }}
            required={true}
            onChange={(e) => setDescription(e.target.value)}
            value={description}
            showToolbar={false}
            showCharacterCount={false}
            maxLength={100}
            showLabelIcon={false}
          />
        </div>
      </div>

    </div>
    <div className="create-update-safe-footer px-3">
      <button className="extension-cancel-button mr-2" onClick={() => navigate(-1)} >
        {t('nonArExtension.cancel')}
      </button>

      <Button
        size="medium"
        text={t("active_directory.submit")}
        variant="primary"
        disabled={false}
        onClick={() => {
          handleAccessRequest()
        }}
      />
      <ToastContainer
        position="bottom-center"
      />
      {showModal && renderConfirmModal()}
    </div>
  </div>
}

export default PamSafeAccessRequest;